/*
创建者 魏强(2018.1.30)
中华老字号 文化传承
*/
<template>
    <div class="china-item">
    	<h2>
    		<img :src="chinaImg2" title="文化传承">
    	</h2>
        <div class="china-content-2" id="china-culture" :style="{background:`url(${china2Bg})`}" >
        	<Carousel
			        v-model="value"
			        :autoplay="setting.autoplay"
			        :autoplay-speed="setting.autoplaySpeed"
			        :dots="setting.dots"
			        :radius-dot="setting.radiusDot"
			        :trigger="setting.trigger"
			        :arrow="setting.arrow"
			        >
			        <CarouselItem class="img-item" v-for="(item,index) in data" :key="index">
			        	<router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" :title="item.tip" :key="item.goodsId">
			        		<img :src="item.imgUrl"  />
			        	</router-link>
			        </CarouselItem>
			    </Carousel>
		</div>
    </div>
</template>
<script>
import chinaImg2 from '../../assets/images/china/china-2.png';
import china2Bg from '../../assets/images/china/china-2-bg.png';
export default{
	props:["data"],
	data(){
		return{
			chinaImg2,
			china2Bg,
			value: 0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow: 'never'
            }
		}
	}
}
</script>
<style scoped lang="less">
#china-culture .img-item {
	text-align:center;
	img{
	height: 370px;
	width: 1120px;
	}
}
</style>



// WEBPACK FOOTER //
// culture.vue?75b99594